module.exports = __webpack_public_path__ + "img/education-careers.b36ddf3d.jpg";